/**
 * Merges estimation passenger rows with the form state used for display.
 * Some providers echo names/prices but omit `passenger_type` — fall back to the form.
 */
export function resolveAirportBusSummaryPassenger(pricedPassenger: any, formPassenger: any) {
  return {
    firstName: pricedPassenger?.first_name ?? formPassenger?.first_name ?? "",
    lastName: pricedPassenger?.last_name ?? formPassenger?.last_name ?? "",
    passengerType: pricedPassenger?.passenger_type ?? formPassenger?.passenger_type,
    price: pricedPassenger?.price,
    currency: pricedPassenger?.currency
  };
}
